module.exports = __webpack_public_path__ + "static/media/marker.7df97da9.png";


//////////////////
// WEBPACK FOOTER
// ./src/marker.png
// module id = 631
// module chunks = 0